export default __webpack_public_path__ + "static/back--24-8e09de1b9aa450cae0168fb25cd9adf8.webp";